import React, { useRef, useState } from 'react'

import dayjs from 'dayjs'

import { TeamsMobileStatusProvider } from '@/components/molecules/Team/TeamsStatusProvider.tsx'
import { useTeams } from '@/model/contexts/useTeams.ts'
import { useTeamsLatestLocation } from '@/model/contexts/useTeamsLatestLocation.ts'

export const AppPageTeamsMobileStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, forceUpdate] = useState(1)
  const timer = useRef<NodeJS.Timeout | undefined>(undefined) // we can save timer in useRef and pass it to child
  const { teams } = useTeams()
  const teamsLatestLocation = useTeamsLatestLocation()
  const status = React.useMemo(() => {
    if (timer.current) {
      clearTimeout(timer.current)
    }
    timer.current = setTimeout(() => {
      timer.current = undefined
      forceUpdate((value) => value + 1)
    }, 1000 * 60)
    return teams.reduce((acc, team) => {
      if (!team.usingMobileApplication) {
        return { ...acc, [team._id]: 'noMobile' }
      }
      const latestLocation = teamsLatestLocation[team._id]
      if (!latestLocation) {
        return { ...acc, [team._id]: 'notConnected' }
      }
      return { ...acc, [team._id]: dayjs().diff(latestLocation.timestamp, 'minutes') > 5 ? 'notConnected' : 'ok' }
    }, {})
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we want to update status every minute
  }, [teams, teamsLatestLocation, state])
  return <TeamsMobileStatusProvider status={status}>{children}</TeamsMobileStatusProvider>
}
